import layer from '../assets/js/layer'
import Clipboard from 'clipboard'

function onFocus(event) {
    var $input = $(event.target);
    if ($input.data('copying')) {
        $input.removeData('copying')
        return;
    }

    event.target.$button.click();
    $input.data('copying', true)
    $input.select();
}
export default{
    name : 'copy',
    directive:{
        bind(el){
            $(el).on('focus', onFocus)
        },
        inserted(el){
            var $parent = $(el).parent();
            el.$button = $('<button type="button" style="display: none">copy</button>');
            $parent.append(el.$button);
            var clipboard = new Clipboard(el.$button[0], {
                text: function (trigger) {
                    return $(el).val();
                }
            });
            clipboard.on('success', () => {
                layer.success('复制成功');
            });
            clipboard.on('error', (e) => {
                console.warn('error copy', e);
//                    layer.alert('复制失败,请手动复制');
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/directives/copy.js